import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasCalidadAtom, puntajeTotalCalidadAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasCalidad = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalCalidadAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasCalidadAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasCalidad;
